function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { closeConfirmation, closeModal, getFullUserDetails, openConfirmation, openModal } from "@common/actions/index";
import Spinner from "@common/components/Spinner";
import SubscriptionSection from "@common/components/account/subscription/SubscriptionSection";
import ToggleSubscription from "@common/components/account/subscription/ToggleSubscription";
import AddonItem from "@common/components/order/subscriptions/AddonItem";
import SubcriptionItem from "@common/components/order/subscriptions/SubscriptionItem";
import { generateRequestBody } from "@common/components/order/subscriptions/utils";
import { durationToLocaleString, formatDate, formatPrice } from "@common/services/helpers";
import request from "@common/services/request";
import { CHANNELS } from "@config/constants";
import { CANCEL_SUBSCRIPTION, COMPONENT_PAYMENT, ROUTE_ORDER_SUBSCRIPTIONS, SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR, SNACKBAR_VARIANT_SUCCESS, STATUS_CODE_SUCCESS, SUBSCRIPTION_ACTIVE } from "@config/constants";
import { Button } from "@material-ui/core";
import { first, isEmpty } from "lodash";
import { withSnackbar } from "notistack";
import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
export var Subscription = function(props) {
    var _first, _userDetails_subscription_flatMap, _userDetails_subscription, _subscriptionsPrismic_plans_items;
    var i18n = props.i18n, userDetails = props.userDetails, _$openModal = props.openModal, screenType = props.screenType, componentMap = props.componentMap, componentName = props.componentName, toggleComponent = props.toggleComponent, _$closeModal = props.closeModal, logos = props.logos, enqueueSnackbar = props.enqueueSnackbar, _$getFullUserDetails = props.getFullUserDetails, _$openConfirmation = props.openConfirmation, _$closeConfirmation = props.closeConfirmation, prismic = props.prismic;
    var childProps = componentMap[componentName].childProps;
    var _useState = _sliced_to_array(useState(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = _sliced_to_array(useState({}), 2), addonLoading = _useState1[0], setAddonLoading = _useState1[1];
    var isMobile = !(screenType.web || screenType.tablet);
    var isFull = ((_first = first(userDetails === null || userDetails === void 0 ? void 0 : userDetails.subscription)) === null || _first === void 0 ? void 0 : _first.planId) === "0100000000000000000000000000000000000000000000000000000000000000";
    var subscriptionsPrismic = prismic === null || prismic === void 0 ? void 0 : prismic.subscriptions;
    useEffect(function() {
        if (!isEmpty(userDetails) && !isEmpty(subscriptionsPrismic)) {
            setLoading(false);
        }
    }, [
        userDetails,
        subscriptionsPrismic
    ]);
    var addons = userDetails === null || userDetails === void 0 ? void 0 : (_userDetails_subscription = userDetails.subscription) === null || _userDetails_subscription === void 0 ? void 0 : (_userDetails_subscription_flatMap = _userDetails_subscription.flatMap(function(sub) {
        return sub === null || sub === void 0 ? void 0 : sub.addons;
    })) === null || _userDetails_subscription_flatMap === void 0 ? void 0 : _userDetails_subscription_flatMap.filter(Boolean);
    var currentActiveSub = first(userDetails === null || userDetails === void 0 ? void 0 : userDetails.subscription);
    var currentActivePlan = first(currentActiveSub === null || currentActiveSub === void 0 ? void 0 : currentActiveSub.plan);
    var cancelAddon = useCallback(function() {
        var _ref = _async_to_generator(function(addonId) {
            var remainingAddons, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        remainingAddons = addons.filter(function(addon) {
                            return (addon === null || addon === void 0 ? void 0 : addon.id) !== addonId;
                        }).map(function(addon) {
                            return _object_spread_props(_object_spread({}, addon), {
                                quantity: 1
                            });
                        });
                        setAddonLoading(function(addonLoading) {
                            return _object_spread_props(_object_spread({}, addonLoading), _define_property({}, addonId, true));
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            request({
                                method: "put",
                                url: "users/me/subscription",
                                data: generateRequestBody({
                                    subscription: currentActivePlan,
                                    r_addons: remainingAddons
                                })
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            _$getFullUserDetails()
                        ];
                    case 3:
                        _state.sent();
                        setAddonLoading(function(addonLoading) {
                            return _object_spread_props(_object_spread({}, addonLoading), _define_property({}, addonId, false));
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        setAddonLoading(function(addonLoading) {
                            return _object_spread_props(_object_spread({}, addonLoading), _define_property({}, addonId, false));
                        });
                        enqueueSnackbar(i18n.errors.generic, {
                            variant: SNACKBAR_VARIANT_ERROR,
                            autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                        });
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(addonId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addons,
        currentActivePlan,
        enqueueSnackbar,
        _$getFullUserDetails,
        i18n
    ]);
    var isSubscriptionActive = (currentActiveSub === null || currentActiveSub === void 0 ? void 0 : currentActiveSub.status) === SUBSCRIPTION_ACTIVE;
    var isFree = (currentActivePlan === null || currentActivePlan === void 0 ? void 0 : currentActivePlan.price) === 0;
    return loading ? /*#__PURE__*/ _jsx("div", {
        className: "loading subscription-wrapper",
        children: /*#__PURE__*/ _jsx(Spinner, {})
    }) : /*#__PURE__*/ _jsxs("div", {
        className: "column subscription-wrapper",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "current-information-wrapper",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "column",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "row title",
                                children: i18n.subscription.currentSubscription
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "row period-wrapper",
                                children: [
                                    !isFree && /*#__PURE__*/ _jsx("span", {
                                        className: "duration",
                                        children: durationToLocaleString(currentActivePlan, i18n)
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "active-period ".concat(isFull || isFree ? "indefinite" : ""),
                                        children: isFull || isFree ? i18n.subscription.indefinite : "".concat(formatDate(currentActiveSub === null || currentActiveSub === void 0 ? void 0 : currentActiveSub.currentTermStart), " - ").concat(formatDate(currentActiveSub === null || currentActiveSub === void 0 ? void 0 : currentActiveSub.currentTermEnd))
                                    })
                                ]
                            })
                        ]
                    }),
                    !isFull && /*#__PURE__*/ _jsx(Button, {
                        component: Link,
                        to: ROUTE_ORDER_SUBSCRIPTIONS,
                        classes: {
                            label: "ux-button-label"
                        },
                        className: "change-button",
                        variant: "outlined",
                        onClick: _$closeModal,
                        children: i18n.subscription.change
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(SubscriptionSection, {
                title: i18n.subscription.plan,
                children: /*#__PURE__*/ _jsx(SubcriptionItem, {
                    subscription: currentActivePlan,
                    subscriptionPrismic: subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_plans_items = subscriptionsPrismic.plans_items) === null || _subscriptionsPrismic_plans_items === void 0 ? void 0 : _subscriptionsPrismic_plans_items.find(function(e) {
                        return e.id === currentActiveSub.planId;
                    }),
                    single: true,
                    onAdditionalItemClick: function() {
                        return _$openModal(CHANNELS, {
                            subscription: currentActivePlan,
                            logos: logos
                        });
                    },
                    active: true,
                    plain: true,
                    showAutoRenewToggle: true,
                    renderTopRightCornerExtra: function() {
                        return !isFull && /*#__PURE__*/ _jsx(ToggleSubscription, {
                            active: isSubscriptionActive,
                            showActiveText: true,
                            terminationDate: formatDate(currentActiveSub === null || currentActiveSub === void 0 ? void 0 : currentActiveSub.currentTermEnd),
                            onCancel: function() {
                                return toggleComponent(CANCEL_SUBSCRIPTION, childProps);
                            },
                            onErrors: function() {
                                return toggleComponent(COMPONENT_PAYMENT.componentName, COMPONENT_PAYMENT.additionalProps);
                            },
                            disableCancel: isFree || i18n.common.brand === "tPLAY"
                        });
                    }
                })
            }),
            !isEmpty(addons) && /*#__PURE__*/ _jsx(SubscriptionSection, {
                title: i18n.subscription.additionalPackages,
                children: addons.map(function(addon) {
                    var addonPrismic = subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : subscriptionsPrismic.r_addons_items.find(function(e) {
                        return e.id === addon.id;
                    });
                    return /*#__PURE__*/ _jsx(AddonItem, {
                        addon: addon,
                        addonPrismic: addonPrismic,
                        single: addons.length <= 1,
                        onAdditionalItemClick: function() {
                            return _$openModal(CHANNELS, {
                                addon: addon,
                                logos: logos
                            });
                        },
                        loading: addonLoading[addon.id],
                        recurring: true,
                        hideIcon: isMobile,
                        plain: true,
                        available: true,
                        renderTopRightCornerExtra: !isFull && function() {
                            return isSubscriptionActive ? /*#__PURE__*/ _jsx(ToggleSubscription, {
                                terminationDate: formatDate(currentActiveSub === null || currentActiveSub === void 0 ? void 0 : currentActiveSub.currentTermEnd),
                                active: true,
                                onCancel: function() {
                                    _$openConfirmation({
                                        message: i18n.account.areYouSureCancelAddon,
                                        declineMethod: _$closeConfirmation,
                                        confirmMethod: function() {
                                            cancelAddon(addon.id);
                                            _$closeConfirmation();
                                        },
                                        declineButtonText: i18n.subscription.goBack
                                    });
                                }
                            }) : /*#__PURE__*/ _jsx("span", {
                                className: "sub-expiration-text",
                                children: i18n.subscription.willBeTerminatedWithSubscriptionExpiration
                            });
                        }
                    }, addon.id);
                })
            })
        ]
    });
};
var mapStateToProps = function(param) {
    var i18n = param.i18n, logos = param.logos, userDetails = param.userDetails, screenType = param.screenType, prismic = param.prismic;
    return {
        i18n: i18n,
        logos: logos,
        userDetails: userDetails,
        screenType: screenType,
        prismic: prismic
    };
};
var mapDispatchToProps = {
    openModal: openModal,
    closeModal: closeModal,
    getFullUserDetails: getFullUserDetails,
    openConfirmation: openConfirmation,
    closeConfirmation: closeConfirmation
};
export default withSnackbar(connect(mapStateToProps, mapDispatchToProps)(Subscription));
